import { KNOWN_HOSTS, DEFAULT_HOST, ENVIRONMENT } from '../config.js';

// Detect server address from the URL
export function detectServerAddress() {
  let host = DEFAULT_HOST;

  if (window.location.hostname === 'localhost') {
    return KNOWN_HOSTS.local;
  }

  return host;
}

// Detect if the page is served over HTTPS.
export function isSecureConnection() {
  return !(ENVIRONMENT === 'production' && window.location.hostname === 'localhost');
}

export function isLocalHost() {
  if (typeof window.location == 'object') {
    return window.location.hostname == 'localhost';
  }
  return false;
}
